import React from 'react';
import { createGlobalStyle } from 'styled-components'
import { useColors } from '../Context/ColorsContext';

import { styled } from "@mui/material/styles";
import { Autocomplete, Card, TableCell, TextField, Select } from "@mui/material";

// const desktopSmallWidth = 1024;
const mobileStartWidth = 426;
const tabletStartWidth = 767;
const desktopStartWidth = 1440;
const desktopStartLargeWidth = 2560;

export const MediaQuerys = Object.freeze({
  mobile: `@media (max-width: ${mobileStartWidth}px)`,
  tablet: `@media (max-width: ${tabletStartWidth}px)`,
  desktop: `@media (max-width: ${desktopStartWidth}px)`,
  desktoplarge: `@media (max-width: ${desktopStartLargeWidth}px)`,
})

const { mobile, tablet, desktop, desktoplarge } = MediaQuerys;

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline: 0; 
    border: 0;
    box-sizing: border-box;
  }

  #root {
    box-shadow: 0 0 10px rgba(0, 0, 0, .05);
    overflow-x: hidden;
    min-height: 100vh;
  }

  html {
    box-sizing: border-box;
    scroll-behavior: smooth;
    font-family: 'Poppins', sans-serif;
    height: 100vh;
    width: 100vw;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  ul, li, h1, h2, h3, h4, h5, p, button {
    margin: 0;
    padding: 0;
    font-size: 14px;
    @media (max-width: 900px) {
      font-size: 12px;
    }
  }

  ul {
    list-style: none;
  }

  button {
    background: transparent;
    cursor: pointer;
    border: 0;
    outline: 0
  }

  body {
    height: 100vh;
    background: ${props => props.colors.background} !important;
    margin: 0 auto;
    overscroll-behavior: none;
    -webkit-font-smoothing: antialiased;
    width: 100%;
    font-size:16px;
    ${desktop} {
    font-size:12px;
    }
    ${tablet} {
      font-size:12px;
    }
    ${mobile} {
      font-size:12px;
    }

  }

  *:focus {
    outline: 0;
  }

  html, body, #root {
    height: 100%;
  }

  a {
    text-decoration: none !important;
  }

  label {
    ${tablet}{
      font-size: 2rem;
    }

    
  }

  input[type="date"] {
    font-family: 'Poppins', sans-serif;
    ${mobile} {
      font-size: 2rem;
    }
    ${tablet} {
      font-size: 10px !important;
    }
    ${desktop} {
      font-size: 0.75rem !important;
    }
    ${desktoplarge} {
      font-size: 14px ;
    }
  }

  input:disabled {
    background: ${props => props.colors.disabledInput} !important;
    border-radius: 4px;
  }

  input:disabled:checked {
    background-color: #0d6efd !important;
  }

  .gm-ui-hover-effect {
    display: none !important;
  }

`

const formItemHeight = "32px";
const formItemBorderRadius = "8px";

export const StickyColumn = styled(TableCell)(({ direction }) => {
  const { colors } = useColors();
  
  return {
    position: 'sticky',
    [direction]: 0,
    background: colors.white,
    width: "auto",
    border: "none",
  }
})

export const CustomCell = styled(TableCell)(({ dataHead }) => {
  const { colors } = useColors();
  const { sticky, direction } = dataHead

  return {
    position: sticky && 'sticky',
    [direction]: sticky && 0,
    background: sticky && colors.white,
    zIndex: sticky && '9',
    border: "none",
    fontSize: "1rem",
    fontWeight: 600,
    paddingTop: "10px !important",
    paddingBottom: "10px !important",
    alignItems: "center",
    padding: "0 16px",
    color: colors.buttonActionColor,
    '& .MuiButtonBase-root': {
      position: 'unset',
    },
    "&:hover": {
      color: colors.buttonActionColor,
      opacity: 0.9
    },
    [desktop]: {
      fontSize: "0.75rem !important",
    },
  }
})

export const ContainerSpeedDial = styled('div')(() => {
  return {
    display: 'none',
    width: 'auto',
    height: 'auto',
    [mobile]: {
      display: 'block',
    }
  }
})

export const BaseAutocomplete = styled(Autocomplete)(({ theme }) => {
  return {
    width: '100%',
    borderRadius: formItemBorderRadius,
    '& .MuiInputBase-root': {
      paddingTop: '4px !important',
      paddingBottom: '4px !important',
      paddingRight: '26px !important',
      borderRadius: '8px',
      border: 'none',
      height: 'auto',
      minHeight: formItemHeight,
      alignItems: 'center',
      flexWrap: 'wrap',
      overflow: 'visible',
      backgroundColor: '#fff',
      '&.Mui-disabled': {
        backgroundColor: '#fbfcfd',
      }
    },
    '.MuiChip-root': {
      height: '20px',
      lineHeight: '20px',
    },
    '& .MuiInputBase-input': {
      height: 'auto !important',
      paddingLeft: '6px !important',
      paddingRight: '3px !important',
      boxSizing: 'border-box',
      fontSize: '14px',
      lineHeight: 'inherit',
      borderRadius: '8px',
      '&.Mui-disabled': {
        color: '#eeeeef !important',
        WebkitTextFillColor: '#fbfcfd !important',
        backgroundColor: '#fbfcfd !important',
      }
    },
    '& .MuiFormControl-root.MuiTextField-root .MuiInputBase-input': {
      paddingLeft: '2px !important',
      paddingRight: '3px !important',
      height: '16px !important',
    },
    '& .MuiOutlinedInput-root': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#dbdcdcff',
        borderWidth: '1px',
        borderStyle: 'solid',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#c0c1c3ff',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#babbc0',
        borderWidth: '1px',
      },
      '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
        borderColor: '#eeeeef',
      }
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '8px',
    },
    '& .MuiInputLabel-root, & .MuiFormLabel-root': {
      fontSize: 14,
    },
    [theme.breakpoints.down('md')]: {
      '& .MuiInputBase-input, & .MuiInputLabel-root, & .MuiFormLabel-root': {
        fontSize: '12px',
      }
    }
  }
});

export const BaseSelect = styled(Select)(({ theme }) => {
  return {
    width: '100%',
    '&.MuiInputBase-root, & .MuiInputBase-root': {
      paddingTop: '4px !important',
      paddingBottom: '4px !important',
      borderRadius: '8px',
      border: 'none',
      height: 'auto',
      minHeight: formItemHeight,
      alignItems: 'center',
      flexWrap: 'wrap',
      overflow: 'visible',
      backgroundColor: '#fff',
      '&.Mui-disabled': {
        backgroundColor: '#fbfcfd',
      }
    },
    '& .MuiInputBase-input, & .MuiSelect-select': {
      height: 'auto !important',
      padding: '0 14px !important',
      boxSizing: 'border-box',
      fontSize: '14px',
      lineHeight: 'inherit',
      borderRadius: '8px',
      '&.Mui-disabled': {
        color: '#eeeeef !important',
        WebkitTextFillColor: '#fbfcfd !important',
        backgroundColor: '#fbfcfd !important',
      }
    },
    '&.MuiOutlinedInput-root, & .MuiOutlinedInput-root': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#dbdcdcff',
        borderWidth: '1px',
        borderStyle: 'solid',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#c0c1c3ff',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#babbc0',
        borderWidth: '1px',
      },
      '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
        borderColor: '#eeeeef',
      }
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '8px',
    },
    [theme.breakpoints.down('md')]: {
      '& .MuiInputBase-input, & .MuiSelect-select': {
        fontSize: '12px',
      },
    }
  }
});

export const BaseTextField = styled(TextField)(({theme, multiline}) => {
  return {
    '& .MuiInputBase-root': {
      borderRadius: '8px',
      border: 'none',
      height: multiline ? 'auto' : formItemHeight,
      backgroundColor: '#fff',
      '&.Mui-disabled': {
        backgroundColor: '#fbfcfd',
      },
      'textarea': {
        padding: '0px !important',
        overflowY: 'auto !important',
      },
    },
    '& .MuiInputBase-root:has(textarea)': {
      paddingTop: '.4rem !important',
      paddingBottom: '.5rem !important',
    },
    '& .MuiInputBase-input': {
      height: multiline ? 'auto !important' : `${formItemHeight} !important`,
      padding: '0 14px !important',
      boxSizing: 'border-box',
      fontSize: '14px',
      lineHeight: multiline ? 'auto !important' : `${formItemHeight} !important`,
      overflowY: multiline ? 'auto !important' : 'hidden',
      borderRadius: '8px',
      '&.Mui-disabled': {
        color: '#a3a3a3 !important',
        WebkitTextFillColor: '#a3a3a3 !important',
        backgroundColor: '#fbfcfd !important',
      },
    },
    '& .MuiOutlinedInput-root': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#dbdcdcff',
        borderWidth: '1px',
        borderStyle: 'solid',
        paddingTop: 0,
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#c0c1c3ff',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#babbc0',
        borderWidth: '1px',
      },
      '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
        borderColor: '#eeeeef',
      }
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '8px',
    },
    '& input[type="date"]': {
      fontSize: '14px !important',
      [theme.breakpoints.down('md')]: {
        fontSize: '12px !important',
      },
    },
    '& .MuiInputLabel-root': {
      top: '16px',
      transform: 'translate(14px, -50%) scale(1)',
    },
    '& .MuiInputLabel-root.MuiInputLabel-shrink': {
      top: 0,
      transform: 'translate(14px, -6px) scale(0.75)',
    },
    [theme.breakpoints.down('md')]: {
      '& .MuiInputBase-input, & .MuiFormLabel-root': {
        fontSize: '12px',
      },
    },
  }
});

export const BaseSelectTextField = styled(BaseTextField)(() => {
  return {
    '& .MuiInputBase-root': {
      paddingTop: '4px !important',
      paddingBottom: '4px !important',
      height: 'auto',
      minHeight: formItemHeight,
      alignItems: 'center',
      flexWrap: 'wrap',
      overflow: 'visible',
    },
    '& .MuiInputBase-input': {
      height: 'auto !important',
      lineHeight: 'inherit',
    },
    '& .MuiInputLabel-root': {
      top: '16px !important',
      transform: 'translate(14px, -50%) scale(1) !important',
    },
    '& .MuiInputLabel-root.MuiInputLabel-shrink': {
      top: '0 !important',
      transform: 'translate(14px, -6px) scale(0.75) !important',
    }
  }
});

export const BaseCard = styled(Card)(() => {
  return {
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 3px 0px',
    borderRadius: formItemBorderRadius,
  }
})

export const GlobalStyle = () => {
  const colors = useColors();

  return (
    <React.Fragment>
      <GlobalStyles colors={colors.colors} />
    </React.Fragment>
  );
};
